<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> OOI / ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text mb-5">
            1. ตัวชี้วัดความสำเร็จ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex flex-column gap-16">
            <!--   OOI   -->
            <div
                v-for="(item, i) in masterData.kpi_masters"
                :key="i"
            >
              <div class="mb-3 black--text txt-bigger">
                ตัวชี้วัดที่ {{ item.no }} {{ item.name }}
              </div>

              <OOILineField
                  v-for="(sub, ind) in item.kpi_sub_masters"
                  :key="ind"
                  :label="sub.name"
                  :unit="sub.unit"
                  :readonly="sub.name === 'รวม'"
                  :field="kpi[sub.id] ? kpi[sub.id].kpi_sub_value : ''"
                  @onChange="setKpiField(sub.id, $event)"
              ></OOILineField>

<!--              <OOILineField-->
<!--                  label="รวม"-->
<!--                  :readonly="true"-->
<!--                  :field="Object.values(kpi).map(x => x.kpi_sub_amount).reduce((a, b) => a + b, 0)"-->
<!--              ></OOILineField>-->
            </div>

          </div>

        </div>

      </div>
    </divcard>

    <divcard>
      <div class="card-part">
        <div>
          <div class="txt-head black--text mb-5">
            2. ภาระงาน
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
              <TextField
                  theme="3"
                  :value="form.s4_p2_name1"
                  @onChange="setFormField('s4_p2_name1', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ตำแหน่ง</div>
              <TextField
                  theme="3"
                  :value="form.s4_p2_position1"
                  @onChange="setFormField('s4_p2_position1', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.s4_p2_work_hrs1"
                  @onChange="setFormField('s4_p2_work_hrs1', $event)"
              ></TextField>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex xs4">
            <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
            <TextField
                theme="3"
                :value="form.s4_p2_name2"
                @onChange="setFormField('s4_p2_name2', $event)"
            ></TextField>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ตำแหน่ง</div>
            <TextField
                theme="3"
                :value="form.s4_p2_position2"
                @onChange="setFormField('s4_p2_position2', $event)"
            ></TextField>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
            <TextField
                theme="3"
                input-type="number"
                :value="form.s4_p2_work_hrs2"
                @onChange="setFormField('s4_p2_work_hrs2', $event)"
            ></TextField>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex xs4">
            <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
            <TextField
                theme="3"
                :value="form.s4_p2_name3"
                @onChange="setFormField('s4_p2_name3', $event)"
            ></TextField>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ตำแหน่ง</div>
            <TextField
                theme="3"
                :value="form.s4_p2_position3"
                @onChange="setFormField('s4_p2_position3', $event)"
            ></TextField>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
            <TextField
                theme="3"
                input-type="number"
                :value="form.s4_p2_work_hrs3"
                @onChange="setFormField('s4_p2_work_hrs3', $event)"
            ></TextField>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            3. ผลลัพธ์
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.s4_p3_quantity"
                  @onChange="setFormField('s4_p3_quantity', $event)"
              ></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.s4_p3_quality"
                  @onChange="setFormField('s4_p3_quality', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            4. ประโยชน์ที่ได้รับ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.s4_p4_quantity"
                  @onChange="setFormField('s4_p4_quantity', $event)"
              ></TextArea>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <TextArea
                  theme="3"
                  height="120"
                  :value="form.s4_p4_quality"
                  @onChange="setFormField('s4_p4_quality', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="mb-3 txt-bigger black--text">
          การประเมินผลกระทบด้านเศรษฐกิจ
          <span class="theme-color-seven">(โปรดกรอกข้อมูล เพื่อใช้ในการพิจารณาโครงการ)</span>
        </div>

        <div>
          <div class="d-flex gap-16 mb-5">
            <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
            <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
            <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
          </div>
          <ul>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ยอดขายรายได้เฉลี่ย/การเพิ่มขึ้นยอดขายของผลิตภัณฑ์ กำไร (บาท)
                </div>
                <div class="flex xs3">
                  <TextField
                      theme="3"
                      input-type="number"
                      :value="form.s4_p4_revenue"
                      @onChange="setFormField('s4_p4_revenue', $event)"
                  ></TextField>
                </div>
                <div class="flex">
                  <TextField
                      theme="3"
                      :value="form.s4_p4_revenue_desc"
                      @onChange="setFormField('s4_p4_revenue_desc', $event)"
                  ></TextField>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ต้นทุนการบริการบริหารจัดการ
                  ทรัพยากรในองค์กรค่าใช้จ่ายการ
                  ผลิต ค่าใช้จ่ายอื่นๆ การจ้างงาน(คน)
                  มูลค่าการจ้างงาน(บาท) การลดค่า
                  ใช้จ่าย ลดต้นทุนในการผลิต
                </div>
                <div class="flex xs3">
                  <TextField
                      theme="3"
                      input-type="number"
                      :value="form.s4_p4_mgm_cost"
                      @onChange="setFormField('s4_p4_mgm_cost', $event)"
                  ></TextField>
                </div>
                <div class="flex">
                  <TextField
                      theme="3"
                      :value="form.s4_p4_mgm_cost_desc"
                      @onChange="setFormField('s4_p4_mgm_cost_desc', $event)"
                  ></TextField>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ประสิทธิภาพ/กำลังการผลิต การ
                  เพิ่มกำลังการผลิต(บาท) มูลค่าของ
                  การเพิ่มประสิทธิภาพหรือคุณภาพ
                  ของผลิตภัณฑ์(บาท)
                </div>
                <div class="flex xs3">
                  <TextField
                      theme="3"
                      input-type="number"
                      :value="form.s4_p4_prod_cap"
                      @onChange="setFormField('s4_p4_prod_cap', $event)"
                  ></TextField>
                </div>
                <div class="flex">
                  <TextField
                      theme="3"
                      :value="form.s4_p4_prod_cap_desc"
                      @onChange="setFormField('s4_p4_prod_cap_desc', $event)"
                  ></TextField>
                </div>
              </div>
            </li>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  การลงทุน มูลค่าการลงทุน R&D
                  (บาท) จำนวนผลิตภัณฑ์ใหม่ที่เสนอ
                  ขายในตลาดต่อปี
                </div>
                <div class="flex xs3">
                  <TextField
                      theme="3"
                      input-type="number"
                      :value="form.s4_p4_investment"
                      @onChange="setFormField('s4_p4_investment', $event)"
                  ></TextField>
                </div>
                <div class="flex">
                  <TextField
                      theme="3"
                      :value="form.s4_p4_investment_desc"
                      @onChange="setFormField('s4_p4_investment_desc', $event)"
                  ></TextField>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้านสังคม
            (จ้างคนในพื้นที่, วัตถุดิบท้องถิ่น)
          </div>
          <div class="flex xs3">
            <TextField
                theme="3"
                input-type="number"
                :value="form.s4_p4_social_impact_eval"
                @onChange="setFormField('s4_p4_social_impact_eval', $event)"
            ></TextField>
          </div>
          <div class="flex">
            <TextField
                theme="3"
                :value="form.s4_p4_social_impact_eval_desc"
                @onChange="setFormField('s4_p4_social_impact_eval_desc', $event)"
            ></TextField>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้าน
            วิทยาศาสตร์และเทคโนโลยี
            (มีเครื่องจักร, ลิขสิทธิ์, งานวิจัย
            ต่อยอด)
          </div>
          <div class="flex xs3">
            <TextField
                theme="3"
                input-type="number"
                :value="form.s4_p4_sci_tech_impact_eval"
                @onChange="setFormField('s4_p4_sci_tech_impact_eval', $event)"
            ></TextField>
          </div>
          <div class="flex">
            <TextField
                theme="3"
                :value="form.s4_p4_sci_tech_impact_eval_desc"
                @onChange="setFormField('s4_p4_sci_tech_impact_eval_desc', $event)"
            ></TextField>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              5. หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค จะเกิดผลกระทบ/ผลเสียหายอย่างไร ท่านจะไปใช้บริการกับหน่วยงานใด
            </span>
          </div>
          <TextArea
              theme="3"
              height="120"
              :value="form.s4_p5_opinion"
              @onChange="setFormField('s4_p5_opinion', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import TextArea from "../../../components/input/TextArea"
import SwitchInset from "../../../components/input/SwitchInset"
import OOILineField from "../../../components/OOILineField"
import AutoBox from "../../../components/input/AutoBox"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "CFormOOI",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: {},
      kpi: {},
      OOIs: [
        {
          kpi_id: 60,
          kpi_name: 'จำนวนผู้เข้าร่วมโครงการ IRTC ต่อปี',
          sub: [
            {
              kpi_sub_name: 'มีผู้เข้าร่วมโครงการ IRTC ประเภทนิติบุคคล'
            }
          ]
        },
        {
          kpi_id: 61,
          kpi_name: 'ผลกระทบเชิงเศรษฐกิจรวมที่เกิดขึ้นจาก IRTC ที่สามารถคำนวณได้ในปี',
          sub: [
            {
              kpi_sub_name: 'มูลค่าของการเพิ่มกำลังการผลิต'
            },
            {
              kpi_sub_name: 'มูลค่าของการลดต้นทุนในการผลิต'
            },
            {
              kpi_sub_name: 'มูลค่าของการเพิ่มประสิทธิภาพหรือคุณภาพของผลิตภัณฑ์'
            },
            {
              kpi_sub_name: 'มูลค่ายอดขายของผลิตภัณฑ์ที่เกิดขึ้นจริงหลังเข้าโครงการ'
            },
            {
              kpi_sub_name: 'มูลค่าของกระบวนการผลิตใหม่ที่มีการผลิตจริง'
            }
          ]
        },
        {
          kpi_id: 62,
          kpi_name: 'มูลค่าการลงทุน R&D ของผู้ประกอบการ IRTC ต่อปี',
          sub: [
            {
              kpi_sub_name: 'ค่าใช้จ่ายที่เป็นเงินสด (in cash) ของโครงการ IRTC'
            },
            {
              kpi_sub_name: 'ค่าใช้จ่ายที่เกี่ยวกับเครื่องมืออุปกรณ์วิจัยพัฒนาที่ใช้ในโครงการ'
            },
            {
              kpi_sub_name: 'ค่าใช้จ่ายในการจัดทำหรือปรับปรุงสถานที่เพื่อดำเนินโครงการ'
            },
            {
              kpi_sub_name: 'ค่าใช้จ่ายในการจ้างบุคลากรวิจัยรวมในปีที่ประเมิน'
            }
          ]
        },
        {
          kpi_id: 63,
          kpi_name: 'คะแนนเฉลี่ยของระดับของเทคโนโลยีที่ผู้ประกอบการ IRTC นำมาใช้',
          sub: [
            {
              kpi_sub_name: 'ระดับความสามารถของเทคโนโลยี (Functionality)'
            },
            {
              kpi_sub_name: 'ระดับความก้าวหน้าของเทคโนโลยี (Newness, Advancement and Trend)'
            },
            {
              kpi_sub_name: 'ระดับความง่ายในการใช้เทคโนโลยี (Usability)'
            },
            {
              kpi_sub_name: 'ระดับการปรับขนาดไปสู่การผลิตเชิงพาณิชย์ (Scalability)'
            },
            {
              kpi_sub_name: 'ระดับความสามารถในการแข่งขันของเทคโนโลยี (Competitiveness)'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState({
      OOIForm: state => state.CForm.OOIForm
    })
  },
  created () {
    if (this.isSameId && !this.masterData.form_c) this.form = this.OOIForm
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString()
            this.kpi[subId] = {}
            this.kpi[subId].id = y.kpi_sub_values.id
            this.kpi[subId].kpi_sub_master_id = y.kpi_sub_values.kpi_sub_master_id
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value
          }
        }
      }
    }
    eventBus.$on('cFormOOI', () => {
      eventBus.$emit('cFormOOISend', {
        ...this.form,
        kpi_sub_values: Object.values(this.kpi)
      })
    })

    eventBus.$on('cFormSummary', () => {
      this.$store.commit('CForm/addSummaryData', {
        partFourForm: this.form,
        kpi: this.kpi
      })
    })
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setKpiField (subId, val) {
      // format {
      //   kpi_sub_master_id: '',
      //   kpi_sub_value: ''
      // }
      this.kpi[subId] = {}
      this.kpi[subId].kpi_sub_master_id = subId
      this.kpi[subId].kpi_sub_value = val
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>